import { useTranslation } from 'react-i18next';

import { MetaPanel } from './MetaPanel';
import { SliceForm } from './SliceForm';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';
import { MerchandisingCollectionSlice } from '@/services/MerchandisingCollectionsService';

interface SliceInfoProps {
  slice: MerchandisingCollectionSlice;
}

export function SliceInfo({ slice }: SliceInfoProps) {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.MerchandisingCollections.pages.Slice.components.SliceInfo',
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
        <CardDescription>{t('description')}</CardDescription>
      </CardHeader>

      <CardContent>
        <div className="space-y-4">
          <SliceForm slice={slice} />
          <MetaPanel slice={slice} />
        </div>
      </CardContent>
    </Card>
  );
}
